var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgContacts = function SvgContacts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M574.701,76.645 C573.664,71.644 569.959,67.626 565.142,66.134 C566.872,64.859 568,62.814 568,60.5 C568,56.634 564.866,53.5 561,53.5 C557.134,53.5 554,56.634 554,60.5 C554,62.814 555.127,64.859 556.858,66.134 C552.04,67.626 548.335,71.644 547.299,76.645 C544.624,73.503 543,69.44 543,65 C543,55.075 551.075,47 561,47 C570.925,47 579,55.075 579,65 C579,69.44 577.376,73.503 574.701,76.645 M561,45 C549.972,45 541,53.972 541,65 C541,76.028 549.972,85 561,85 C572.028,85 581,76.028 581,65 C581,53.972 572.028,45 561,45",
    transform: "translate(-539 -43)",
    fillRule: "evenodd"
  })));
};
export default SvgContacts;